function ButtonBase(): any {
  return {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
        size: 'medium'
      }
    }
  };
}

export { ButtonBase };
